// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"48":"8dd0324a4b5e209e3f93","60":"d0c94c821f3f40a3a582","232":"50cb4d37a4d954d030f6","279":"966fcc428b3d6a4e7016","289":"5c48d9b29139de383f62","802":"615a42da4acc5c652eab"}[chunkId] + ".js";
};